<template>
  <div class="com-box">
    <van-collapse v-model="activeNames">
      <van-collapse-item title="虚拟数据" name="virtualData" class="collapse-item">
        <van-field v-model="form.joinPeopleNum" type="digit" label="已参与人数" label-width="18em" placeholder="请输入" @blur="onFormChange"/>
        <van-field v-model="form.viewPeopleNum" type="digit" label="已浏览人数" label-width="18em" placeholder="请输入" @blur="onFormChange"/>
      </van-collapse-item>
      <van-collapse-item title="任务设置" name="taskConf" class="collapse-item">
        <div class="collapse-item-title">经销商角色任务</div>
        <van-field v-model="form.newNumCustomer" type="digit" label="拉新数" label-width="18em" placeholder="请输入" @blur="onFormChange"/>
        <van-field v-model="form.registNumCustomer" type="digit" label="报名数" label-width="18em" placeholder="请输入" @blur="onFormChange"/>
        <div class="collapse-item-title">店长角色任务</div>
        <van-field v-model="form.newNumStore" type="digit" label="拉新数" label-width="18em" placeholder="请输入" @blur="onFormChange"/>
        <van-field v-model="form.registNumStore" type="digit" label="报名数" label-width="18em" placeholder="请输入" @blur="onFormChange"/>
        <div class="collapse-item-title">导购角色任务</div>
        <van-field v-model="form.newNumEmployee" type="digit" label="拉新数" label-width="18em" placeholder="请输入" @blur="onFormChange"/>
        <van-field v-model="form.registNumEmployee" type="digit" label="报名数" label-width="18em" placeholder="请输入" @blur="onFormChange"/>
      </van-collapse-item>
    </van-collapse>
    <div class="field-item bottom-radius">
      <div class="field-item-title">参与成功轮播</div>
      <!-- <van-switch v-model="form.boolShowNotice" size="24px" active-color="#FF6B31" inactive-color="#f4f4f4" @change="onFormChange"/> -->
      <van-radio-group v-model="form.boolShowNotice" direction="horizontal" icon-size="16px" checked-color="#FF6B31" @change="onFormChange">
        <van-radio :name="false">关闭</van-radio>
        <van-radio :name="true">开启</van-radio>
      </van-radio-group>
    </div>
    <!-- <template>
      <div class="field-item bottom-radius">
        <div class="field-item-title">报名成功短信设置</div>
        <van-switch v-model="form.boolDefinitionSignUpSms" size="24px" active-color="#FF6B31" inactive-color="#f4f4f4" @change="onFormChange"/>
      </div>
      <van-field
        v-if="form.boolDefinitionSignUpSms"
        v-model="form.definitionSignUpSms"
        rows="1"
        type="textarea"
        maxlength="50"
        placeholder="请输入短信内容"
        show-word-limit
        @blur="onFormChange"
      />
    </template> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Object
  },
 computed: {
  ...mapGetters({
    // 经销商
    isDistributor: 'isDistributor',
    // 店长
    isShopowner: 'isShopowner',
    // 导购
    isGuide: 'isGuide',
    // 活动老师
    isTeacher: 'isTeacher',
  }),
 },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.initForm(newVal);
        }
      },
      deep: true,
      immediate: true
    },
  },
  data() {
    return {
      activeNames: [],
      form: {
        joinPeopleNum: '',
        viewPeopleNum: '',
        newNum: '',
        registNum: '',
        boolShowNotice: true
      },
      message: ''
    }
  },
  methods: {
    initForm(val) {
      if (val) {
        this.form = {...val};
      }
    },
    onFormChange() {
      this.$emit('change', this.form);
    },
  }
}
</script>

<style lang="stylus" scoped>
.com-box
  margin 15px
  >>> .van-collapse
    border-radius: 8px 8px 0 0
    overflow hidden
  .collapse-item
    >>> .van-collapse-item__title .van-cell__title
      font-weight 600
    >>> .van-collapse-item__content
      padding 0
      .van-cell__title
        color #909399
    .collapse-item-title {
      color: #666666;
      margin-left: 15px;
      padding-top: 10px;
    }
.field-item
  display: flex
  justify-content: space-between
  align-items: center
  padding 10px 16px
  font-size 14px
  background-color: #fff
  &-title
    color #323233
    font-weight 600

.bottom-radius
  border-radius: 0 0 8px 8px

</style>